import { render, staticRenderFns } from "./Krpano.vue?vue&type=template&id=63671fe4&"
import script from "./Krpano.vue?vue&type=script&lang=js&"
export * from "./Krpano.vue?vue&type=script&lang=js&"
import style0 from "./Krpano.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports